/**
 * EIAP Cluster Interfaces
 *
 * These interfaces define the structure for EIAP Cluster forms and data
 * Updated for normalized endpoint structure
 */

// Type definitions for EIAP Cluster
export type EnvironmentCategory = 'Production' | 'Staging' | 'Development' | 'Testing';

// Type form endpoints
export type EndpointsType = 'rlo' | 'eic' | 'eolm';

export enum EndpointType {
  ENM = 'ENM',
  RLO = 'RLO',
  EIC = 'EIC',
  EOLM = 'EOLM',
}

// Endpoint configuration for RLO, EIC, EOLM
export interface EndpointFormData {
  url: string;
  user: string;
  password: string;
  clientId: string;
  clientSecret: string;
  tlsCertificate: string;
  status?: 'connected' | 'disconnected' | 'error';
}

// Normalized endpoint from backend
export interface EiapEndpoint {
  id: string;
  name: string;
  eiapClusterId: string;
  targetEnvToolTypeId: string;
  url: string;
  user: string;
  password: string;
  sftpIp?: string;
  sftpPath?: string;
  tlsCertificate?: string;
  category: string;
  clientId?: string;
  clientSecret?: string;
  enabled: boolean;
  createdBy: string;
  updatedBy: string;
  createdAt: Date;
  updatedAt: Date;
  targetEnvToolType: {
    id: string;
    name: string; // 'RLO', 'EIC', 'EOLM', 'ENM'
    description: string;
    isMulti: string;
    fieldsDescription: string;
    showName: string;
  };
  selected?: boolean;
  [key: string]: any;
}

// Main EIAP Cluster form data
export interface EiapClusterFormData {
  // Cluster Information
  name: string;
  category: EnvironmentCategory;
  description?: string;

  // Endpoints
  rloEndpoint: EndpointFormData;
  eicEndpoint: EndpointFormData;
  eolmEndpoint: EndpointFormData;

  linkedEnms: EndpointFormData[];
}

// For API requests/responses (normalized structure)
export interface EiapClusterData {
  id?: string;
  name: string;
  category: EnvironmentCategory;
  description?: string;
  endpoints: EiapEndpoint[];
  status: 'online' | 'offline' | 'error';
  linkedEnms: string[];
  createdAt?: Date;
  updatedAt?: Date;
}

// Alias for backward compatibility
export type EiapCluster = EiapClusterData;

// Props for the dialog component
export interface AddEditEiapClusterDialogProps {
  open: boolean;
  cluster?: EiapClusterData | null;
  onSave: (cluster: EiapClusterData) => void;
  onClose: () => void;
}

// Props for the form component
export interface EiapClusterFormProps {
  cluster?: EiapClusterData | null;
  isDialog?: boolean;
  saveNow?: number;
  openDialog?: boolean;
  onFormError?: () => void;
  onSave?: (cluster: EiapClusterData) => void;
}
